import { h, Component } from "preact";

import ChatAds from "containers/ChatAds";

import Container from "components/Container";

import { fetchLink } from "./request";

class LandingPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const url = this.props.matches.url;
    const location = this.props.matches.location;

    if (url) {
      this.setState({ loading: true })
      await fetchLink(this.props, url, location);
      this.setState({ loading: false })
    } else {
      this.setState({ loading: false });
    }
  }

  render() {
    if (this.state.loading) return <Container />
    return <ChatAds {...this.props} />
  }
}

export default LandingPage;
